import React from 'react';
import { useProjectState } from '@starflow/app/store';
import { sortUnits } from '@starflow/app/helpers/flow';
import DragWrapper from '../DragWrapper';
import { translate } from '@shakkerai/util-i18n';
import Unit from './Unit';
import './index.scss';

const UnitContainer = () => {
  const units = useProjectState('units');
  const nodeMap = useProjectState('nodeMap');
  const currentNodeId = useProjectState('currentNodeId');
  const { nodes = [], title = '' } = units;

  return (
    <div className="flex items-center h-[50px]">
      <div className="w-[170px] flex-shrink-0 border-r-[1px] border-[#EBEBEB] flex items-center justify-center h-full">
        {title || translate('flow_g_title')}
      </div>
      <div className="flex tiny-scrollbar overflow-x-auto h-full">
        <DragWrapper
          sortUpdate={(nodes) => sortUnits(nodes)}
          dataList={nodes}
          className="flex items-center h-full mr-4"
        >
          {nodes.map((nodeId, idx) => (
            <Unit key={idx} node={nodeMap[nodeId]} isSelected={currentNodeId === nodeId} sortNum={idx} />
          ))}
        </DragWrapper>
      </div>
    </div>
  );
};

export default UnitContainer;
